var map = {
	"./backgroud.png": 3624,
	"./banner-en-new.png": 3857,
	"./banner-pt-new.png": 9136,
	"./login_back_image.png": 3981,
	"./package1.jpg": 4025,
	"./package2.jpg": 6910,
	"./package3.jpg": 4955,
	"./paycard.png": 6346,
	"./whatsapp.png": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;